<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
export default {
  name: 'ownerList',
  
  data () {
    return {
        ko : ko,
        optionData : optionData,
        dateOption : [],
        roleType : null,
        entity: null,
        keywordType : '_name',
        currency : null,
        payment_method : null,
        country : null,
        dateType : {value:'created_at',label : '등록일'},

        showCreateFromEmailModal: false,
        createFromEmailInput: '',
        createFromEmailSite: 'my',
        createFromEmailSiteOptions: [
            { label: 'my.soundrepublica.com', value: 'my' },
            { label: 'studio.soundrepublica.com', value: 'studio' },
        ],

        file : null,
        startDate : null,
        endDate: null,
        entity_tax_exemption : null,
        entity_tax_exemptionOption : [
            {value:'false',label : '과세'},
            {value:'true', label : '면세'},
        ],
        managerList : [
            // {label : '담당자 없음',value : 'null'},
            // {label : 'Brian',value : 'Brian'},
            // {label : 'Leonie',value : 'Leonie'},
            // {label : 'Chaey',value : 'Chaey'},
            // {label : 'Celine',value : 'Celine'},
            // {label : 'Michaella',value : 'Michaella'},
            // {label : 'Terrence',value : 'Terrence'},
            // {label : 'Marty',value : 'Marty'},
        ],
        manager : null,
        apOption : null, // 선급계약여부  

        
        page: {
            pageSize : 50,
            currentPage: 1,                       // 현재 페이지
            totalPage: 0,                         // 총 페이지수
        },          
        gridOptions :{ // 테이플 옵션
            onRowClicked: (event)=>{
                this.viewDetail(event)
            },
        },
        defaultColDef: {
            domLayout:'auto',
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        columnDefs: [
            {headerName: '권리자구분', field: 'role', filter: false,width: 125,},
            {headerName: 'ID(email)',  field: 'email',  filter: false,width: 275},
            {headerName: '가입일',      field: 'created_at',     filter: false,width: 200,},
            {headerName: '국적',      field: 'nationality',     filter: false,width: 150, },
            {headerName: '사업자구분',      field: 'entity',     filter: false,width: 150, },
            {headerName: '권리자명(성이름)',    field: 'name',   filter: false,width: 250},
           
            {headerName: '회사명',    field: 'company',   filter: false,width: 150},
            {headerName: '정산화폐',    field: 'currency',   filter: false,width: 100},
            {headerName: '지급방법',       field: 'payment_method',      filter: false,width: 150},
            {headerName: '거주국',    field: 'country',   filter: false,width: 150},
            {headerName: '권리자잔액',      field: 'balance',     filter: false,width: 225},
            {headerName: '선급금계약',        field: 'advancepayments',       filter: false,width: 125},
            {headerName: '컨트랙터유무',  field: 'contractor', filter: false,width: 125},
            {headerName: '연락처',  field: 'phone', filter: false,width: 200},
            {headerName: '예금주',  field: 'bankaccount_name', filter: false,width: 150}
        ],
        tableData:[
        ],       
        keyword : '',
        testMessage: "최고당!",
        total: 0,                                       // 총 회원 수
        filtered: 0,                                    // 필터 회원 수
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        if(this.$route.query.roleType){
            this.roleType= this.$route.query.roleType
        }
        if(this.$route.query.entity){
            this.entity= this.$route.query.entity
        }
        if(this.$route.query.currency){
            this.currency= this.$route.query.currency
        }
        if(this.$route.query.country){
            this.country= this.$route.query.country
        }
        if(this.$route.query.payment_method){
            this.payment_method= this.$route.query.payment_method
        }
        if(this.$route.query.entity_tax_exemption){
            this.entity_tax_exemption= this.$route.query.entity_tax_exemption
        }
        if(this.$route.query.sr_representative){
            this.manager= this.$route.query.sr_representative
        }
        if(this.$route.query._ap){
            this._ap = this.$route.query._ap
        }
        if(this.$route.query.file){
            this._file = this.$route.queryfile
       }
        if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field'] 
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start']
            this.endDate = this.$route.query['date_end'] 
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        this.managerCall();
        })
    },
    computed: {
        listData(){
            return this.tableData.map((result, index) =>{
                return this.dataTemplate(result, index)
            })
        },
    },
    watch: {
        'page.currentPage'(e){
            if(e== null){
                return false
            }
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        createFromEmail() {
            const email = this.createFromEmailInput.trim()
            if (!email) {
                this.alert({ msg: '이메일을 입력해주세요.' })
                return
            }
            const site = this.createFromEmailSite || 'my'
            this.loadingShow()
            this.$store.dispatch('POST_USER_FROM_EMAIL', { email, site })
                .then(() => {
                    this.loadingHide()
                    this.showCreateFromEmailModal = false
                    this.createFromEmailInput = ''
                    this.createFromEmailSite = 'my'
                    this.alert({ msg: 'Licensor가 생성되었습니다.' })
                    this.callList()
                })
                .catch(error => {
                    this.loadingHide()
                    const status = error?.response?.status
                    switch (status) {
                        case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(() => { this.$router.push('/login') })
                            break
                        default:
                            this.alert({ msg: error?.response?.data?.message ?? '생성에 실패했습니다.' })
                            break
                    }
                })
        },
        resetSearch (){
            
            this.page.currentPage = 1
            this.keyword = null
            this.keywordType = '_name'
            this.roleType = null
            this.entity = null
            this.startDate = null
            this.endDate = null
            this.country = null
            this.payment_method = null
            this.entity_tax_exemption = null
            this.manager = null
            this._ap = null
            this.file = null
           
            this.allList() 
        },
        dataTemplate(value, index){
            const template = {
                index: index,
                id: value.id,
                role: value.role,
                email: value.email,
                created_at: this.dateFormat(value.created_at, "yyyy-MM-dd HH:mm:ss")
            }
            // licensor
            if (value.licensor) {
                const licensor = value.licensor
                if(licensor) {
                    const add = {
                        nationality: licensor.hasOwnProperty('nationality')? this.$options.filters.switch_country(licensor.nationality): null,
                        entity: licensor.hasOwnProperty('entity')? this.$options.filters.switch_entity(value.licensor.entity): null,
                        name: (licensor.family_name ? licensor.family_name  :' ' ) + " " + (licensor.given_name ? licensor.given_name : ' '),
                        company: licensor.hasOwnProperty('company')? licensor.company: null,
                        currency: licensor.currency? this.$options.filters.switch_currency(licensor.currency): null,
                        /* 운용시 활성화 payment_method: licensor.hasOwnProperty('bankaccount')? licensor.bankaccount.payment_method: null, */
                        payment_method: !isEmpty(licensor.bankaccount)? this.$options.filters.switch_payment_method(licensor.bankaccount.payment_method): null,
                        // 운용시 활성화 country: licensor.entity_address.hasOwnProperty('country')? licensor.entity_address.country: null,
                        country: !isEmpty(licensor.entity_address) && licensor.entity_address.country? licensor.entity_address.country: null,
                        balance: licensor.balance? this.numberFormatAll(licensor.balance) + ' ' + this.$options.filters.uppercase(licensor.currency): 0 + ' ' + this.$options.filters.uppercase(licensor.currency),
                        advancepayments: licensor.advancepayments? licensor.advancepayments.length: null,
                        contractor: licensor.contractor_id? 'Y':'N',
                        phone: licensor.phone ? licensor.phone_countrycode+ ' ' + licensor.phone : '',
                        bankaccount_name : licensor.bankaccount && licensor.bankaccount.name? licensor.bankaccount.name  : ''
                    }
                    Object.assign(template, add)
                }
            }

            // contractor
            if (value.contractor) {
                const contractor = value.contractor
                if(contractor) {
                const add = {
                    nationality: !isEmpty(contractor.nationality)? this.$options.filters.switch_country(contractor.nationality): null,
                    entity: !isEmpty(contractor.entity)? this.$options.filters.switch_entity(contractor.entity): null,
                    name: contractor.family_name+ ' ' + contractor.given_name,
                    company: !isEmpty(contractor.company)? contractor.company: null,
                    currency: !isEmpty(contractor.currency)? this.$options.filters.switch_currency(contractor.currency): null,
                    /* 운용시 활성화 payment_method: contractor.hasOwnProperty('bankaccount')? contractor.bankaccount.payment_method: null, */
                    payment_method: !isEmpty(contractor.bankaccount)? this.$options.filters.switch_payment_method(contractor.bankaccount.payment_method): null,
                    /* 운용시 활성화 country: contractor.entity_address.hasOwnProperty('country')? contractor.entity_address.country: null, */
                    country: !isEmpty(contractor.entity_address)? this.$options.filters.switch_country(contractor.entity_address.country): null,
                    balance: !isEmpty(contractor.balance)? contractor.balance: 0,
                    advancepayments: !isEmpty(contractor.advancepayments)? contractor.advancepayments.length: null,
                    phone: contractor.phone ? contractor.phone_countrycode+ ' ' + contractor.phone : '',
                    bankaccount_name : contractor.bankaccount && contractor.bankaccount.name? contractor.bankaccount.name  : ''
                    
                }
                Object.assign(template, add)
                }
            }
            return template
        },
        dateFormat(value, dateformat) {
            if(value) return format(parseISO(value), dateformat)
        },
        callList(){
            this.loadingShow()
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
            }
            let query = {
                
            }
            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(!this.valCheck(this.manager)) {
                option['sr_representative'] = this.manager
                query['sr_representative'] = this.manager
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }
            if(this.roleType && this.roleType !='') {
                option['role'] = this.roleType
                query['roleType'] = this.roleType
            }
            if(!this.valCheck(this.entity) ){
                option['entity'] = this.entity
                query['entity'] = this.entity
            }
            if(!this.valCheck(this.currency) ){
                option['currency'] = this.currency
                query['currency'] = this.currency
            }
            if(!this.valCheck(this.country) ){
                option['country'] = this.country
                query['country'] = this.country
            }
            if(!this.valCheck(this.payment_method) ){
                option['payment_method'] = this.payment_method
                query['payment_method'] = this.payment_method
            }
            
            
            if(!this.valCheck(this.entity_tax_exemption) ){
                option['entity_tax_exemption'] = this.entity_tax_exemption
                query['entity_tax_exemption'] = this.entity_tax_exemption
            }
            if(!this.valCheck(this.apOption)){
                option['_ap'] = this.apOption
                query['_ap'] = this.apOption
            }
            if(!this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                option['date_field'] = 'created_at'
                query['date_start'] = this.startDate
                query['date_end'] = this.endDate
            }

            if(!this.valCheck(this.file) ){
                option['_file'] = this.file
                query['_file'] = this.file
            }
            // if(!this.valCheck(this.startDate) && !this.valCheck(this.endDate) ){
            //     option['startDate'] = this.startDate
            //     query['startDate'] = this.startDate
            //     option['endDate'] = this.endDate
            //     query['endDate'] = this.endDate
            // }
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.$store.dispatch('GETUSER', option)
            .then(result =>{
                this.loadingHide()
                console.log(result);
                this.tableData  = result.items // 권리자 목록
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                this.loadingHide()
                const status = error.response.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg:error.response.data.message })
                    break;
                }
            })
        },
        managerCall(){
            this.loadingShow()
            const option = {
                sort: 'admin_nickname',
                sortorder: 'asc',
                page: 0 ,
                limit: 100,
            }
            option['state'] = 'verified'
            option['role'] = 'admin'
            this.$store.dispatch('GETUSER', option)
            .then(result =>{
                this.loadingHide()
                this.managerList = [
                    ...result.items
                 
                ]
            }).catch(error=>{
                this.loadingHide()
                const status = error.response.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg:error.response.data.message })
                    break;
                }
            })
        },
        list_search(){
            this.page.currentPage = 1  // 초기화
            
            this.callList()
        },
        viewDetail(event){
            console.log(event)
            this.$router.push('/member/detail/'+event.data.id)
        },
        
        getExcel(){
            const option = {
            }
            let query = {}
            if(this.manager != '') {
                option['sr_representative'] = this.manager
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
            }
            if(this.roleType && this.roleType !='') {
                option['role'] = this.roleType
            }
            if(!this.valCheck(this.entity) ){
                option['entity'] = this.entity
            }
            if(!this.valCheck(this.currency) ){
                option['currency'] = this.currency
            }
            if(!this.valCheck(this.country) ){
                option['country'] = this.country
            }
            if(!this.valCheck(this.payment_method) ){
                option['payment_method'] = this.payment_method
            }
            if(!this.valCheck(this.entity_tax_exemption) ){
                option['entity_tax_exemption'] = this.entity_tax_exemption
            }
            
            if(!this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                option['date_field'] = 'created_at'
            }
            if(!this.valCheck(this.file) ){
                option['_file'] = this.file
            }
            if(Object.keys(option).length == 0){
            this.alert({msg:'한가지 이상의 검색 조건을 입력해주세요.'});
            return false;
            }
            this.loadingShow();
            this.$store.dispatch('GET_USER_EXCEL', option)
            .then(result =>{
                this.loadingHide();
                console.log('result',result)
                this.getExcelFileDown(result)
            }).catch(error=>{
            this.loadingHide();
            const status = error.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message})
                break;
            }
            })
        
        },
    }
}
</script>

<style scoped>

</style>
